import {Text, Stack} from "@chakra-ui/react";

export default function TempAnnounceSuccess() {

    return (
        <Stack paddingTop="15%">
        <Text fontSize="2xl">Latest Announcement has been updated on the Virtual Gallery !</Text>
        </Stack>
    )
}